<template>
  <div v-if="role.schoolleider">
    <XVactionbar>
      <template slot="actionbuttons">
        <div id="pnlButtonBar">
          <div class="btn-group">
            <button type="button" id="btnTerug" class="btn btn-primary btn-xs" @click.prevent="btnTerug">
              <font-awesome-icon icon="chevron-left" />
              {{ translation(16881) }}
            </button>
            <button
              type="button"
              id="btnOpslaan"
              class="btn btn-primary btn-xs"
              @click.prevent="btnOpslaan"
              :disabled="btnToggles.btnOpslaan"
            >
              <font-awesome-icon :icon="['far', 'save']" />
              {{ translation(16852) }}
            </button>
          </div>
        </div>
      </template>
    </XVactionbar>
    <div class="row">
      <div class="col-12">
        <span id="lblTitel" class="titel">{{ translation(16880) }}</span>
      </div>
    </div>
    <div class="row lblBeschrijving" v-if="translation(16877) !== ''">
      <div class="col-12">
        <p v-html="translation(16877)"></p>
      </div>
    </div>
    <fieldset class="margin20 margin20bottom" v-if="bevoegdGezagenData !== []">
      <!-- bestuur multiselect -->
      <XVbootstraprow
        :label="translation(16878)"
        :required="true"
        :haserror="errors.has('msBestuur')"
        :errormessage="errors.first('msBestuur')"
      >
        <multiselect
          id="msBestuur"
          name="msBestuur"
          @click.prevent
          v-model="formInput.msBestuur"
          :options="bevoegdGezagenData"
          :placeholder="translation(15450)"
          label="labelText"
          track-by="labelText"
          openDirection="bottom"
          :maxHeight="200"
          v-validate="'required'"
          :allow-empty="false"
          :data-vv-as="translation(16878)"
          :multiple="false"
          :clear-on-select="false"
          :hide-selected="true"
          @input="msInputBestuur"
          selectLabel
        >
          <template slot="tag" slot-scope="props">
            <span class="multiselect__tag">
              <span>{{ props.option.labelText + ' (' + props.option.value + ')' }}</span>
              <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="props.remove(props.option)"></i>
            </span>
          </template>
          <template slot="noResult"
            ><span>{{ translation(16851) }}</span></template
          >
          <template slot="noOptions"
            ><span>{{ translation(16851) }}</span></template
          >
        </multiselect>
      </XVbootstraprow>
      <!-- functie  -->
      <XVbootstraprow
        :label="translation(16870)"
        :required="true"
        :haserror="errors.has('rbFunctie')"
        :errormessage="errors.first('rbFunctie')"
      >
        <XVradiobuttonlist
          id="rbFunctie"
          v-model="formInput.rbFunctie"
          :datalist="functieData"
          v-validate="'required'"
          name="rbFunctie"
          :data-vv-as="translation(16870)"
        ></XVradiobuttonlist>
      </XVbootstraprow>
      <!-- startdatum -->
      <XVbootstraprow
        :label="translation(16846)"
        :required="true"
        :haserror="errors.has('tbxStartDatum')"
        :errormessage="errors.first('tbxStartDatum')"
      >
        <XVdate
          id="tbxStartDatum"
          name="tbxStartDatum"
          v-model.trim="formInput.iStartDatum"
          :data-vv-as="translation(16846)"
          v-validate="{ XVDateDefault: true, required: true }"
        ></XVdate>
      </XVbootstraprow>
      <!-- einddatum -->
      <XVbootstraprow
        :label="translation(16847)"
        :haserror="errors.has('tbxEindDatum') || isAfter(formInput.iStartDatum, formInput.iEindDatum)"
        :errormessage="einddatumErrorMessage"
      >
        <XVdate
          id="tbxEindDatum"
          name="tbxEindDatum"
          v-model.trim="formInput.iEindDatum"
          :data-vv-as="translation(16847)"
          v-validate="{ XVDateDefault: true }"
        ></XVdate>
      </XVbootstraprow>
      <!-- SchoolvestigingNietAanwezig -->
      <XVbootstraprow id="lblSchoolvestigingNietAanwezig" :label="translation(16862)">
        <XVcheckbox
          :disabled="schoolInList"
          v-model="formInput.cbSchoolvestigingNietAanwezig"
          id="cbSchoolvestigingNietAanwezig"
        ></XVcheckbox>
      </XVbootstraprow>
      <!-- Schoolvestiging(en) -->
      <XVbootstraprow
        :label="translation(16849)"
        :required="formInput.cbSchoolvestigingNietAanwezig === false"
        :haserror="errors.has('msSchoolvestiging') && formSubmitted"
        :errormessage="errors.first('msSchoolvestiging')"
      >
        <multiselect
          id="msSchoolvestiging"
          name="msSchoolvestiging"
          v-model="formInput.msSchoolvestiging"
          :options="vestigingenData"
          :placeholder="translation(16850)"
          label="labelText"
          track-by="labelText"
          openDirection="bottom"
          :maxHeight="200"
          v-validate="formInput.cbSchoolvestigingNietAanwezig === false ? 'required' : ''"
          :allow-empty="true"
          :data-vv-as="translation(16849)"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :hide-selected="true"
          selectLabel
          @select="formInput.cbSchoolvestigingNietAanwezig = formInput.msSchoolvestiging > 0"
        >
          <template slot="tag" slot-scope="props">
            <span class="multiselect__tag">
              <span>{{ props.option.labelText + ' (' + props.option.value + ')' }}</span>
              <i aria-hidden="true" tabindex="1" class="multiselect__tag-icon" @click="props.remove(props.option)"></i>
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <span>{{ props.option.labelText + ' (' + props.option.value + ')' }}</span>
          </template>
          <template slot="noResult"
            ><span>{{ translation(16851) }}</span></template
          >
          <template slot="noOptions"
            ><span>{{ translation(16851) }}</span></template
          ></multiselect
        >
      </XVbootstraprow>
    </fieldset>
  </div>
</template>
<script>
import { FAMixin, util } from 'pevueglobal'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { sync } from 'vuex-pathify'
import Multiselect from 'vue-multiselect'
import { isAfter } from 'date-fns'

export default {
  mixins: [FAMixin],
  components: {
    Multiselect,
  },
  data: function () {
    return {
      formSubmitted: false,
    }
  },
  async mounted() {
    await this.getRole()
    await this.getBestuurEnFuncties()
  },
  computed: {
    ...mapGetters('SRPOOvereenkomsten', [
      'role',
      'srpoTable',
      'formInput',
      'bevoegdGezagenData',
      'functieData',
      'vestigingenData',
      'btnToggles',
    ]),
    formInput: sync('SRPOOvereenkomsten/formInput'),
    einddatumErrorMessage() {
      if (this.errors.has('tbxEindDatum')) {
        return this.errors.first('tbxEindDatum')
      } else if (isAfter(this.formInput.iStartDatum, this.formInput.iEindDatum)) {
        return this.translation(16879)
      } else {
        return ''
      }
    },
    schoolInList() {
      return this.formInput.msSchoolvestiging.length > 0
    },
  },
  methods: {
    isAfter,
    ...mapMutations(['addNotification']),
    ...mapMutations('SRPOOvereenkomsten', ['toggleBtnOpslaan']),
    ...mapActions('SRPOOvereenkomsten', [
      'getBestuurEnFuncties',
      'getVestigingen',
      'resetSelectedVestigingen',
      'insertOvereenkomst',
      'getRole',
    ]),
    btnTerug() {
      this.$router.push({ name: 'overzicht' })
    },
    msInputBestuur() {
      if (this.formInput.msSchoolvestiging.length > 0) {
        this.resetSelectedVestigingen()
      }
      this.getVestigingen()
    },
    btnOpslaan() {
      const functies = this.functieData.map((m) => ({
        id: m.value,
        naam: m.labelText,
      }))

      const functie = functies.find((f) => {
        return f.id === this.formInput.rbFunctie
      })

      this.toggleBtnOpslaan(true)
      this.formSubmitted = true
      this.$validator.validate().then((result) => {
        if (result) {
          let schoolvestigingenArr = this.formInput.msSchoolvestiging.map((a) => a.value)
          let formInputOvereenkomsten = {
            PersonId: parseInt(util.UgetCookie('pe_PersonID'), 10),
            ProfGroupId: parseInt(util.UgetCookie('pe_activeProfGroup'), 10),
            BevoegdGezagNummer: this.formInput.msBestuur.value,
            functie: functie,
            StartDatum: util.DateForDatabaseV2(this.formInput.iStartDatum),
            EindDatum: util.DateForDatabaseV2(this.formInput.iEindDatum),
            VestigingNummers: schoolvestigingenArr,
          }
          this.insertOvereenkomst(formInputOvereenkomsten)
        } else {
          this.toggleBtnOpslaan(false)
          this.addNotification({
            groupname: 'warning',
            message: this.translation(14642),
          })
        }
      })
    },
  },
}
</script>

<style scoped>
fieldset .row:first-child {
  margin-top: 20px;
}
</style>
